import { useState } from 'react';
import type { Dispatch } from 'react';
import type { Issue, ScmProviderDescriptor } from '../../api/types';
import type { ActivityCreationContentAction } from '../../activity-creation/activityCreationReducer';
import type { RepoHierarchyValue } from './RepoHierarchyPicker';

function emptyHierarchy(): RepoHierarchyValue {
  return { owner: null, project: null, repository: null, branch: null };
}

export function useCreationIssue(
  dispatch: Dispatch<ActivityCreationContentAction>,
) {
  const [hierarchy, setHierarchy] = useState(emptyHierarchy);
  const [selected, setSelected] = useState<Issue | null>(null);
  const reset = () => {
    setHierarchy(emptyHierarchy());
    setSelected(null);
  };
  const changeHierarchy = (next: RepoHierarchyValue) => {
    const changed =
      next.repository?.externalId !== hierarchy.repository?.externalId;
    setHierarchy(next);
    if (changed) {
      setSelected(null);
      dispatch({ type: 'card.removed' });
    }
  };
  const select = (issue: Issue | null, provider: ScmProviderDescriptor) => {
    setSelected(issue);
    if (!issue) {
      dispatch({ type: 'card.removed' });
      return;
    }
    dispatch({
      type: 'card.selected',
      card: {
        provider: provider.id,
        externalId: issue.externalId,
        title: issue.title,
        context: issue.description ?? '',
      },
    });
  };
  return { hierarchy, selected, reset, changeHierarchy, select };
}
